<script>
import HeaderButton from '@/components/AppHeaderButton'

export default {
  components: {
    HeaderButton
  },
  methods: {
    isSelected(name, dropdowOptions) {
      if (typeof dropdowOptions != 'undefined') {
        for (let option of dropdowOptions) {
          if (new RegExp(option.isSelected).test(this.$route.name)) {
            return true
          }
        }
      }
      return new RegExp(name).test(this.$route.name)
    },
    goToHome() {
      if (!this.$route.meta.single) {
        this.$router.push({ name: 'home' })
      }
    }
  },
  computed: {
    username: function() {
      return this.$store.state.username
    },
    otherDropdowns: function() {
      return [
        {
          path: { name: 'FormSearch', params: { formType: 'roles' } },
          isSelected: 'role.*',
          text: 'Roles',
          selected: this.isSelected('role.*')
        },
        {
          path: { name: 'FormSearch', params: { formType: 'groups' } },
          isSelected: 'group.*',
          text: 'Groups',
          selected: this.isSelected('group.*')
        },
        {
          path: { name: 'FormSearch', params: { formType: 'emails' } },
          isSelected: 'email.*',
          text: 'Email Lists',
          selected: this.isSelected('email.*')
        },
        {
          path: { name: 'FormSearch', params: { formType: 'institutions' } },
          isSelected: 'institution.*',
          text: 'Institutions',
          selected: this.isSelected('institution.*')
        }
      ]
    }
  }
}
</script>

<template>
  <div id="header">
    <div class="padding"></div>
    <div class="container">
      <b-row no-gutters>
        <b-col sm="2" id="logo-col">
          <img
            @click="goToHome"
            alt="ARM logo"
            class="logo img-responsive"
            src="../assets/images/ARM_Logo.png"
          />
        </b-col>
        <b-col sm>
          <div id="title">
            <span @click="goToHome">{{
              $route.meta.appShortTitle || 'PEOPLE ADMINISTRATION'
            }}</span>
          </div>
        </b-col>
        <b-col sm>
          <header-button
            text="PEOPLE"
            :path="{ name: 'FormSearch', params: { formType: 'people' } }"
            :selected="isSelected('people.*|person.*')"
            icon="users"
            v-if="!$route.meta.single"
          />
        </b-col>
        <b-col sm>
          <header-button
            text="REPORTS"
            path="reportList"
            :selected="isSelected('[rR]eport.*')"
            icon="list-alt"
            v-if="
              !$route.meta.single && /people=people/.test($store.state.role)
            "
          />
        </b-col>
        <b-col sm>
          <header-button
            text="OTHER"
            :selected="isSelected('other', otherDropdowns)"
            :dropdown="otherDropdowns"
            icon="chevron-circle-down"
            v-if="
              !$route.meta.single && /people=people/.test($store.state.role)
            "
          />
        </b-col>
        <b-col sm class="account">
          <header-button
            class="account-button"
            text="MY ACCOUNT"
            icon="user-circle"
            v-b-modal.account-modal
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style>
#logo-col {
  text-align: center;
}

#header {
  width: 100%;
  height: 113px;
  background-color: #fff;
}

#header .padding {
  height: 13px;
  width: 100%;
  background-color: #8abedc;
}

#header .container {
  height: 100px;
  line-height: 100px;
}

#header .logo {
  width: 100%;
  max-width: 300px;
  display: inline-block;
  vertical-align: middle;
}

#title {
  line-height: 100px;
  text-align: center;
}

#title span {
  color: #194173;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: bold;
  line-height: 1;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
}

.account {
  background-color: #3e6da7;
  cursor: pointer;
}

.account * {
  color: white;
}
</style>
